import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Area from '../../components/charts/Area';
import Honeycomb from '../../components/charts/Honeycomb';
import Pie from '../../components/charts/Pie';

const HONEYCOMB_DATA = [{
  'hc-a2': 'AL',
  name: 'Alabama',
  region: 'South',
  x: 6,
  y: 7,
  value: 4849377
}, {
  'hc-a2': 'AK',
  name: 'Alaska',
  region: 'West',
  x: 0,
  y: 0,
  value: 737732
}, {
  'hc-a2': 'AZ',
  name: 'Arizona',
  region: 'West',
  x: 5,
  y: 3,
  value: 6745408
}, {
  'hc-a2': 'AR',
  name: 'Arkansas',
  region: 'South',
  x: 5,
  y: 6,
  value: 2994079
}, {
  'hc-a2': 'CA',
  name: 'California',
  region: 'West',
  x: 5,
  y: 2,
  value: 39250017
}, {
  'hc-a2': 'CO',
  name: 'Colorado',
  region: 'West',
  x: 4,
  y: 3,
  value: 5540545
}, {
  'hc-a2': 'CT',
  name: 'Connecticut',
  region: 'Northeast',
  x: 3,
  y: 11,
  value: 3596677
}, {
  'hc-a2': 'DE',
  name: 'Delaware',
  region: 'South',
  x: 4,
  y: 9,
  value: 935614
}, {
  'hc-a2': 'DC',
  name: 'District of Columbia',
  region: 'South',
  x: 4,
  y: 10,
  value: 7288000
}, {
  'hc-a2': 'FL',
  name: 'Florida',
  region: 'South',
  x: 8,
  y: 8,
  value: 20612439
}, {
  'hc-a2': 'GA',
  name: 'Georgia',
  region: 'South',
  x: 7,
  y: 8,
  value: 10310371
}, {
  'hc-a2': 'HI',
  name: 'Hawaii',
  region: 'West',
  x: 8,
  y: 0,
  value: 1419561
}, {
  'hc-a2': 'ID',
  name: 'Idaho',
  region: 'West',
  x: 3,
  y: 2,
  value: 1634464
}, {
  'hc-a2': 'IL',
  name: 'Illinois',
  region: 'Midwest',
  x: 3,
  y: 6,
  value: 12801539
}, {
  'hc-a2': 'IN',
  name: 'Indiana',
  region: 'Midwest',
  x: 3,
  y: 7,
  value: 6596855
}, {
  'hc-a2': 'IA',
  name: 'Iowa',
  region: 'Midwest',
  x: 3,
  y: 5,
  value: 3107126
}, {
  'hc-a2': 'KS',
  name: 'Kansas',
  region: 'Midwest',
  x: 5,
  y: 5,
  value: 2904021
}, {
  'hc-a2': 'KY',
  name: 'Kentucky',
  region: 'South',
  x: 4,
  y: 6,
  value: 4413457
}, {
  'hc-a2': 'LA',
  name: 'Louisiana',
  region: 'South',
  x: 6,
  y: 5,
  value: 4649676
}, {
  'hc-a2': 'ME',
  name: 'Maine',
  region: 'Northeast',
  x: 0,
  y: 11,
  value: 1330089
}, {
  'hc-a2': 'MD',
  name: 'Maryland',
  region: 'South',
  x: 4,
  y: 8,
  value: 6016447
}, {
  'hc-a2': 'MA',
  name: 'Massachusetts',
  region: 'Northeast',
  x: 2,
  y: 10,
  value: 6811779
}, {
  'hc-a2': 'MI',
  name: 'Michigan',
  region: 'Midwest',
  x: 2,
  y: 7,
  value: 9928301
}, {
  'hc-a2': 'MN',
  name: 'Minnesota',
  region: 'Midwest',
  x: 2,
  y: 4,
  value: 5519952
}, {
  'hc-a2': 'MS',
  name: 'Mississippi',
  region: 'South',
  x: 6,
  y: 6,
  value: 2984926
}, {
  'hc-a2': 'MO',
  name: 'Missouri',
  region: 'Midwest',
  x: 4,
  y: 5,
  value: 6093000
}, {
  'hc-a2': 'MT',
  name: 'Montana',
  region: 'West',
  x: 2,
  y: 2,
  value: 1023579
}, {
  'hc-a2': 'NE',
  name: 'Nebraska',
  region: 'Midwest',
  x: 4,
  y: 4,
  value: 1881503
}, {
  'hc-a2': 'NV',
  name: 'Nevada',
  region: 'West',
  x: 4,
  y: 2,
  value: 2839099
}, {
  'hc-a2': 'NH',
  name: 'New Hampshire',
  region: 'Northeast',
  x: 1,
  y: 11,
  value: 1326813
}, {
  'hc-a2': 'NJ',
  name: 'New Jersey',
  region: 'Northeast',
  x: 3,
  y: 10,
  value: 8944469
}, {
  'hc-a2': 'NM',
  name: 'New Mexico',
  region: 'West',
  x: 6,
  y: 3,
  value: 2085572
}, {
  'hc-a2': 'NY',
  name: 'New York',
  region: 'Northeast',
  x: 2,
  y: 9,
  value: 19745289
}, {
  'hc-a2': 'NC',
  name: 'North Carolina',
  region: 'South',
  x: 5,
  y: 9,
  value: 10146788
}, {
  'hc-a2': 'ND',
  name: 'North Dakota',
  region: 'Midwest',
  x: 2,
  y: 3,
  value: 739482
}, {
  'hc-a2': 'OH',
  name: 'Ohio',
  region: 'Midwest',
  x: 3,
  y: 8,
  value: 11614373
}, {
  'hc-a2': 'OK',
  name: 'Oklahoma',
  region: 'South',
  x: 6,
  y: 4,
  value: 3878051
}, {
  'hc-a2': 'OR',
  name: 'Oregon',
  region: 'West',
  x: 4,
  y: 1,
  value: 3970239
}, {
  'hc-a2': 'PA',
  name: 'Pennsylvania',
  region: 'Northeast',
  x: 3,
  y: 9,
  value: 12784227
}, {
  'hc-a2': 'RI',
  name: 'Rhode Island',
  region: 'Northeast',
  x: 2,
  y: 11,
  value: 1055173
}, {
  'hc-a2': 'SC',
  name: 'South Carolina',
  region: 'South',
  x: 6,
  y: 8,
  value: 4832482
}, {
  'hc-a2': 'SD',
  name: 'South Dakota',
  region: 'Midwest',
  x: 3,
  y: 4,
  value: 853175
}, {
  'hc-a2': 'TN',
  name: 'Tennessee',
  region: 'South',
  x: 5,
  y: 7,
  value: 6651194
}, {
  'hc-a2': 'TX',
  name: 'Texas',
  region: 'South',
  x: 7,
  y: 4,
  value: 27862596
}, {
  'hc-a2': 'UT',
  name: 'Utah',
  region: 'West',
  x: 5,
  y: 4,
  value: 2942902
}, {
  'hc-a2': 'VT',
  name: 'Vermont',
  region: 'Northeast',
  x: 1,
  y: 10,
  value: 626011
}, {
  'hc-a2': 'VA',
  name: 'Virginia',
  region: 'South',
  x: 5,
  y: 8,
  value: 8411808
}, {
  'hc-a2': 'WA',
  name: 'Washington',
  region: 'West',
  x: 2,
  y: 1,
  value: 7288000
}, {
  'hc-a2': 'WV',
  name: 'West Virginia',
  region: 'South',
  x: 4,
  y: 7,
  value: 1850326
}, {
  'hc-a2': 'WI',
  name: 'Wisconsin',
  region: 'Midwest',
  x: 2,
  y: 5,
  value: 5778708
}, {
  'hc-a2': 'WY',
  name: 'Wyoming',
  region: 'West',
  x: 3,
  y: 3,
  value: 584153
}];

const HONEYCOMB_OPTIONS = {
  colorAxis: {
    dataClasses: [{
      from: 0,
      to: 1000000,
      color: '#F9EDB3',
      name: '< 1M'
    }, {
      from: 1000000,
      to: 5000000,
      color: '#FFC428',
      name: '1M - 5M'
    }, {
      from: 5000000,
      to: 20000000,
      color: '#FF7987',
      name: '5M - 20M'
    }, {
      from: 20000000,
      color: '#FF2371',
      name: '> 20M'
    }]
  },

  tooltip: {
    headerFormat: '',
    pointFormat: 'The population of <b> {point.name}</b> is <b>{point.value}</b>'
  },

  plotOptions: {
    series: {
      dataLabels: {
        enabled: true,
        format: '{point.hc-a2}',
        color: '#000000',
        style: {
          textOutline: false
        }
      }
    }
  },

};

const PIE_DATA = [{
  name: 'Chrome',
  y: 74.77,
  sliced: true,
  selected: true
}, {
  name: 'Edge',
  y: 12.82
}, {
  name: 'Firefox',
  y: 4.63
}, {
  name: 'Safari',
  y: 2.44
}, {
  name: 'Internet Explorer',
  y: 2.02
}, {
  name: 'Other',
  y: 3.28
}];

const AREA_DATA = [{
  name: 'USA',
  data: [
    null, null, null, null, null, 2, 9, 13, 50, 170, 299, 438, 841,
    1169, 1703, 2422, 3692, 5543, 7345, 12298, 18638, 22229, 25540,
    28133, 29463, 31139, 31175, 31255, 29561, 27552, 26008, 25830,
    26516, 27835, 28537, 27519, 25914, 25542, 24418, 24138, 24104,
    23208, 22886, 23305, 23459, 23368, 23317, 23575, 23205, 22217,
    21392, 19008, 13708, 11511, 10979, 10904, 11011, 10903, 10732,
    10685, 10577, 10526, 10457, 10027, 8570, 8360, 7853, 5709, 5273,
    5113, 5066, 4897, 4881, 4804, 4717, 4571, 4018, 3822, 3785, 3805,
    3750, 3708, 3708
  ]
}, {
  name: 'USSR/Russia',
  data: [null, null, null, null, null, null, null, null, null,
    1, 5, 25, 50, 120, 150, 200, 426, 660, 863, 1048, 1627, 2492,
    3346, 4259, 5242, 6144, 7091, 8400, 9490, 10671, 11736, 13279,
    14600, 15878, 17286, 19235, 22165, 24281, 26169, 28258, 30665,
    32146, 33486, 35130, 36825, 38582, 40159, 38107, 36538, 35078,
    32980, 29154, 26734, 24403, 21339, 18179, 15942, 15442, 14368,
    13188, 12188, 11152, 10114, 9076, 8038, 7000, 6643, 6286, 5929,
    5527, 5215, 4858, 4750, 4650, 4600, 4500, 4490, 4300, 4350, 4330,
    4310, 4495, 4477
  ]
}];

const AREA_OPTIONS = {
  accessibility: {
    description: 'Image description: An area chart compares the nuclear stockpiles of the USA and the USSR/Russia between 1945 and 2017. The number of nuclear weapons is plotted on the Y-axis and the years on the X-axis. The chart is interactive, and the year-on-year stockpile levels can be traced for each country. The US has a stockpile of 6 nuclear weapons at the dawn of the nuclear age in 1945. This number has gradually increased to 369 by 1950 when the USSR enters the arms race with 6 weapons. At this point, the US starts to rapidly build its stockpile culminating in 32,040 warheads by 1966 compared to the USSR’s 7,089. From this peak in 1966, the US stockpile gradually decreases as the USSR’s stockpile expands. By 1978 the USSR has closed the nuclear gap at 25,393. The USSR stockpile continues to grow until it reaches a peak of 45,000 in 1986 compared to the US arsenal of 24,401. From 1986, the nuclear stockpiles of both countries start to fall. By 2000, the numbers have fallen to 10,577 and 21,000 for the US and Russia, respectively. The decreases continue until 2017 at which point the US holds 4,018 weapons compared to Russia’s 4,500.'
  },
  xAxis: {
    allowDecimals: false,
    labels: {
      formatter() {
        return this.value; // clean, unformatted number for year
      }
    },
    accessibility: {
      rangeDescription: 'Range: 1940 to 2017.'
    }
  },
  yAxis: {
    title: {
      text: 'Nuclear weapon states'
    },
    labels: {
      formatter() {
        return `${this.value / 1000}k`;
      }
    }
  },
  tooltip: {
    pointFormat: '{series.name} had stockpiled <b>{point.y:,.0f}</b><br/>warheads in {point.x}'
  },
  plotOptions: {
    area: {
      pointStart: 1940,
      marker: {
        enabled: false,
        symbol: 'circle',
        radius: 2,
        states: {
          hover: {
            enabled: true
          }
        }
      }
    }
  },
};

const Charts = () => (
  <Row className='styles-section' id="charts">
    <Col sm="12" className='main-page-title'>
      <h3>
        Charts
      </h3>
    </Col>
    <Col xs="12" md="6">
      <Honeycomb data={HONEYCOMB_DATA} options={HONEYCOMB_OPTIONS} title={'Honeycomb example'} />
    </Col>
    <Col xs="12" md="6">
      <Pie data={PIE_DATA} title={'Pie example'} />
    </Col>

    <Col xs="12" md="6">
      <Area data={AREA_DATA} title={'Area example'} options={AREA_OPTIONS} />
    </Col>
  </Row>);

export default Charts;